import Campaign from "./campaign";
import Omnishot from "./omnishot";
import Trade from './trade'

export default {
    Campaign,
    Omnishot,
    Trade
}